<template>
    <a-select :default-value="null" style="width: 200px" @change="handleChange">
        <a-select-option v-for="template in templates" :key="template.id" :value="template.id">
            {{ template.name }}
        </a-select-option>
    </a-select>
</template>

<script>
export default {
    name: "TemplateSelector",
    data() {
        return {
            templates: [
                [
                    {
                        id: 1,
                        name: "Hoş Geldiniz Kampanyası",
                        template: `
          <mjml>
            <mj-body>
              <mj-section>
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/4CAF50/FFFFFF?text=TechStore+Logo"></mj-image>
                  <mj-divider border-color="#4CAF50"></mj-divider>
                  <mj-image width="600px" src="https://via.placeholder.com/600x400/FFFFFF/4CAF50?text=Teknoloji+Dunyasina+Hosgeldiniz"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="20px" color="#4CAF50" font-family="Helvetica" align="center">Aramıza Hoş Geldiniz!</mj-text>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica" align="center">TechStore ailesine katıldığınız için çok mutluyuz.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/4CAF50?text=Yeni+Urunler"></mj-image>
                </mj-column>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">En yeni teknoloji ürünlerimizi keşfetmeye hazır mısınız? Akıllı telefonlar, laptoplar, tabletler ve daha fazlası için web sitemizi ziyaret edin.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">Ayrıca, sadece yeni üyelerimiz için özel indirimler sunuyoruz. Hemen alışverişe başlayın ve indirimlerden yararlanın!</mj-text>
                </mj-column>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/4CAF50?text=Ozel+Indirimler"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-button background-color="#4CAF50" font-size="16px" href="https://www.techstore.com">Alışverişe Başla</mj-button>
                </mj-column>
              </mj-section>
              <mj-section background-color="#F0F0F0">
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/FFFFFF/4CAF50?text=TechStore+Logo"></mj-image>
                  <mj-text font-size="12px" color="#999" font-family="Helvetica" align="center">Bu e-posta size TechStore tarafından gönderilmiştir.</mj-text>
                  <mj-social font-size="15px" icon-size="30px" mode="horizontal">
                    <mj-social-element name="facebook" href="https://www.facebook.com/techstore"></mj-social-element>
                    <mj-social-element name="twitter" href="https://www.twitter.com/techstore"></mj-social-element>
                    <mj-social-element name="instagram" href="https://www.instagram.com/techstore"></mj-social-element>
                  </mj-social>
                </mj-column>
              </mj-section>
            </mj-body>
          </mjml>
        `,
                    },
                    {
                        id: 2,
                        name: "Büyük İndirim Fırsatı",
                        template: `
          <mjml>
            <mj-body>
              <mj-section>
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/FF5722/FFFFFF?text=TechStore+Logo"></mj-image>
                  <mj-divider border-color="#FF5722"></mj-divider>
                  <mj-image width="600px" src="https://via.placeholder.com/600x400/FFFFFF/FF5722?text=Inanilmaz+Indirimler"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="20px" color="#FF5722" font-family="Helvetica" align="center">%50'ye Varan İndirimler Başladı!</mj-text>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica" align="center">En sevdiğiniz ürünlerde inanılmaz indirimler sizi bekliyor.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">Akıllı telefonlar, laptoplar, tabletler ve daha fazlasında %50'ye varan indirimler için acele edin. Stoklarla sınırlı bu fırsatı kaçırmayın!</mj-text>
                </mj-column>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/FF5722?text=Indirimli+Urunler"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/FF5722?text=Kampanya+Detaylari"></mj-image>
                </mj-column>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">İndirim kampanyamız 1-31 Ağustos tarihleri arasında geçerlidir. Bu süre içinde dilediğiniz kadar alışveriş yapabilir ve indirimlerden yararlanabilirsiniz.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-button background-color="#FF5722" font-size="16px" href="https://www.techstore.com/indirimler">İndirimleri Keşfet</mj-button>
                </mj-column>
              </mj-section>
              <mj-section background-color="#F0F0F0">
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/FFFFFF/FF5722?text=TechStore+Logo"></mj-image>
                  <mj-text font-size="12px" color="#999" font-family="Helvetica" align="center">Bu e-posta size TechStore tarafından gönderilmiştir.</mj-text>
                  <mj-social font-size="15px" icon-size="30px" mode="horizontal">
                    <mj-social-element name="facebook" href="https://www.facebook.com/techstore"></mj-social-element>
                    <mj-social-element name="twitter" href="https://www.twitter.com/techstore"></mj-social-element>
                    <mj-social-element name="instagram" href="https://www.instagram.com/techstore"></mj-social-element>
                  </mj-social>
                </mj-column>
              </mj-section>
            </mj-body>
          </mjml>
        `,
                    },
                    {
                        id: 3,
                        name: "Yeni Ürün Lansmanı",
                        template: `
          <mjml>
            <mj-body>
              <mj-section>
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/2196F3/FFFFFF?text=TechStore+Logo"></mj-image>
                  <mj-divider border-color="#2196F3"></mj-divider>
                  <mj-image width="600px" src="https://via.placeholder.com/600x400/FFFFFF/2196F3?text=Yeni+Akilli+Telefon"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="20px" color="#333" font-family="Helvetica" align="center">Yeni Akıllı Telefonumuzla Tanışın</mj-text>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica" align="center">En son teknolojilerle donatılmış yeni akıllı telefonumuz şimdi satışta.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/2196F3?text=Urun+Ozellikleri"></mj-image>
                </mj-column>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">6.5 inç OLED ekran, 5G desteği, 128GB depolama, 6GB RAM, 48MP arka kamera ve 32MP ön kamera gibi etkileyici özelliklere sahip.</mj-text>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-text font-size="16px" color="#333" font-family="Helvetica">Ön siparişe özel, ilk 100 kişiye %10 indirim ve ücretsiz kablosuz şarj cihazı hediye ediyoruz. Bu fırsatı kaçırmayın!</mj-text>
                </mj-column>
                <mj-column>
                  <mj-image width="300px" src="https://via.placeholder.com/300x200/FFFFFF/2196F3?text=On+Siparis+Firsati"></mj-image>
                </mj-column>
              </mj-section>
              <mj-section>
                <mj-column>
                  <mj-button background-color="#2196F3" font-size="16px" href="https://www.techstore.com/yeni-urun">Ürünü İncele</mj-button>
                </mj-column>
              </mj-section>
              <mj-section background-color="#F0F0F0">
                <mj-column>
                  <mj-image width="200px" src="https://via.placeholder.com/200x100/FFFFFF/2196F3?text=TechStore+Logo"></mj-image>
                  <mj-text font-size="12px" color="#999" font-family="Helvetica" align="center">Bu e-posta size TechStore tarafından gönderilmiştir.</mj-text>
                  <mj-social font-size="15px" icon-size="30px" mode="horizontal">
                    <mj-social-element name="facebook" href="https://www.facebook.com/techstore"></mj-social-element>
                    <mj-social-element name="twitter" href="https://www.twitter.com/techstore"></mj-social-element>
                    <mj-social-element name="instagram" href="https://www.instagram.com/techstore"></mj-social-element>
                  </mj-social>
                </mj-column>
              </mj-section>
            </mj-body>
          </mjml>
        `,
                    },
                    {
                        id: 4,
                        name: "Terk Edilmiş Sepet Hatırlatması",
                        template: `
        <mjml>
          <mj-body>
            <mj-section>
              <mj-column>
                <mj-image width="200px" src="https://via.placeholder.com/200x100/FFC107/FFFFFF?text=TechStore+Logo"></mj-image>
                <mj-divider border-color="#FFC107"></mj-divider>
                <mj-image width="600px" src="https://via.placeholder.com/600x400/FFFFFF/FFC107?text=Alisveris+Sepetiniz+Sizi+Bekliyor"></mj-image>
                <mj-text font-size="20px" color="#FFC107" font-family="Helvetica" align="center">Sepetinizi Unuttunuz!</mj-text>
                <mj-text font-size="16px" color="#333" font-family="Helvetica" align="center">Sepetinizde harika ürünler bıraktınız. Alışverişinizi tamamlamak için hemen geri dönün.</mj-text>
                <mj-button background-color="#FFC107" font-size="16px" href="https://www.techstore.com/sepetim">Sepete Git</mj-button>
              </mj-column>
            </mj-section>
            <mj-section background-color="#F0F0F0">
              <mj-column>
                <mj-image width="200px" src="https://via.placeholder.com/200x100/FFFFFF/FFC107?text=TechStore+Logo"></mj-image>
                <mj-text font-size="12px" color="#999" font-family="Helvetica" align="center">Bu e-posta size TechStore tarafından gönderilmiştir.</mj-text>
                <mj-social font-size="15px" icon-size="30px" mode="horizontal">
                  <mj-social-element name="facebook" href="https://www.facebook.com/techstore"></mj-social-element>
                  <mj-social-element name="twitter" href="https://www.twitter.com/techstore"></mj-social-element>
                  <mj-social-element name="instagram" href="https://www.instagram.com/techstore"></mj-social-element>
                </mj-social>
              </mj-column>
            </mj-section>
          </mj-body>
        </mjml>
      `,
                    },
                    {
                        id: 5,
                        name: "Sadakat Programı Özel Teklif",
                        template: `
        <mjml>
          <mj-body>
            <mj-section>
              <mj-column>
                <mj-image width="200px" src="https://via.placeholder.com/200x100/9C27B0/FFFFFF?text=TechStore+Logo"></mj-image>
                <mj-divider border-color="#9C27B0"></mj-divider>
                <mj-image width="600px" src="https://via.placeholder.com/600x400/FFFFFF/9C27B0?text=Sadakat+Programi+Ozel+Firsatlar"></mj-image>
                <mj-text font-size="20px" color="#9C27B0" font-family="Helvetica" align="center">Sadakat Programımıza Özel Fırsatlar</mj-text>
                <mj-text font-size="16px" color="#333" font-family="Helvetica" align="center">Size özel indirimler ve ayrıcalıklarla dolu sadakat programımıza katılın.</mj-text>
                <mj-button background-color="#9C27B0" font-size="16px" href="https://www.techstore.com/sadakat">Detayları Gör</mj-button>
              </mj-column>
            </mj-section>
            <mj-section background-color="#F0F0F0">
              <mj-column>
                <mj-image width="200px" src="https://via.placeholder.com/200x100/FFFFFF/9C27B0?text=TechStore+Logo"></mj-image>
                <mj-text font-size="12px" color="#999" font-family="Helvetica" align="center">Bu e-posta size TechStore tarafından gönderilmiştir.</mj-text>
                <mj-social font-size="15px" icon-size="30px" mode="horizontal">
                  <mj-social-element name="facebook" href="https://www.facebook.com/techstore"></mj-social-element>
                  <mj-social-element name="twitter" href="https://www.twitter.com/techstore"></mj-social-element>
                  <mj-social-element name="instagram" href="https://www.instagram.com/techstore"></mj-social-element>
                </mj-social>
              </mj-column>
            </mj-section>
          </mj-body>
        </mjml>
      `,
                    },
                ],
            ],
        };
    },
    methods: {
        handleChange(value) {
            const selectedTemplate = this.templates.find((template) => template.id === value);
            this.$emit("template-select", selectedTemplate.template);
        },
    },
};
</script>
